import { render, staticRenderFns } from "./EffectLegislator.vue?vue&type=template&id=0e9197aa&"
import script from "./EffectLegislator.vue?vue&type=script&lang=js&"
export * from "./EffectLegislator.vue?vue&type=script&lang=js&"
import style0 from "./EffectLegislator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports